// Review "KPI tablosuyla çelişki adayı" kutusu — uyarı başına yerel "yoksay" (P2-7, gerçek LLM turu).
// Saf yardımcılar (bileşen render testi yok: jsdom kurulu değil, period-ui kalıbı). Kayıt
// localStorage'da, proje + bölüm başına; sunucuya gitmez, başka kullanıcıyı etkilemez.
import type { KpiTextWarning } from "@mahir/shared";

export interface StorageLike {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
}

export const KPI_WARNINGS_COPY = {
  title: "KPI tablosuyla çelişki adayı",
  summary: (visible: number, ignored: number): string =>
    ignored > 0 ? `${visible} uyarı · ${ignored} yoksayıldı` : `${visible} uyarı`,
  lead: "metindeki sayı, yakınında geçen göstergenin tablodaki değeriyle uyuşmuyor. Metni ya da tabloyu kontrol edin:",
  ignore: "yoksay",
  ignoreTitle: "Bu uyarıyı yoksay (yalnız bu tarayıcıda)",
  restore: "yoksayılanları geri getir",
  allIgnored: "Tüm uyarılar yoksayıldı.",
  // TODO-KPI-27 — birim dönüşümüyle eşdeğer sayı: çelişki değil, nötr bilgi satırı
  unitNoteTitle: "Birim farkı",
  unitNoteSuffix: "— tabloyla eşdeğer, çelişki değil",
} as const;

/** TODO-KPI-27: `unitNote` satırları uyarı sayılmaz — kutu ikiye ayırır. */
export function splitUnitNotes(warnings: readonly KpiTextWarning[]): {
  warnings: KpiTextWarning[];
  unitNotes: KpiTextWarning[];
} {
  const out = { warnings: [] as KpiTextWarning[], unitNotes: [] as KpiTextWarning[] };
  for (const w of warnings) (w.kind === "unitNote" ? out.unitNotes : out.warnings).push(w);
  return out;
}

/**
 * güvenlik/UX taraması 2026-10-08 (S-L1): anahtar kullanıcı bazlı — paylaşılan tarayıcıda bir
 * sonraki kullanıcı önceki kullanıcının "yoksay" kararlarını görmez; logout `clearUserLocalState`
 * `mahir.review.` önekini temizler.
 */
export function kpiWarningsStorageKey(
  userId: string,
  projectId: string,
  sectionCode: string,
): string {
  return `mahir.review.kpiWarnIgnored.v1.${userId}.${projectId}.${sectionCode}`;
}

/** Uyarı kimliği — metin düzenlenince konum (sectionIndex) kayar, gösterge + ham ifade + tablo değeri sabittir. */
export function kpiWarningKey(w: KpiTextWarning): string {
  return `${w.indicatorCode}|${w.raw}|${w.tableValue}`;
}

export function loadIgnoredKeys(storage: StorageLike | null | undefined, key: string): Set<string> {
  try {
    const raw = storage?.getItem(key);
    if (!raw) return new Set();
    const parsed: unknown = JSON.parse(raw);
    return new Set(
      Array.isArray(parsed) ? parsed.filter((x): x is string => typeof x === "string") : [],
    );
  } catch {
    return new Set();
  }
}

export function saveIgnoredKeys(
  storage: StorageLike | null | undefined,
  key: string,
  ignored: ReadonlySet<string>,
): void {
  try {
    storage?.setItem(key, JSON.stringify([...ignored]));
  } catch {
    // private window / kota — sessizce geç (bellek içi durum çalışmaya devam eder)
  }
}

export function splitKpiWarnings(
  warnings: readonly KpiTextWarning[],
  ignored: ReadonlySet<string>,
): { visible: KpiTextWarning[]; ignoredCount: number } {
  const visible: KpiTextWarning[] = [];
  let ignoredCount = 0;
  for (const w of warnings) {
    if (ignored.has(kpiWarningKey(w))) ignoredCount += 1;
    else visible.push(w);
  }
  return { visible, ignoredCount };
}
